import { IProductCategory } from '../../interfaces';
import styles from './DesignCategory.module.css';
import { useRouter } from 'next/router';
import { useGlobalContext } from '../../lib/context';
import { NavLink } from '../ui';
import CustomSlideArrow from '../shared/customSlideArrow/CustomSlideArrow';
import { pushRoute } from '@/lib/helpers/common';
import React, { useEffect, useRef } from 'react';
type Props = {
    categorySlug: string;
    data: IProductCategory[];
    sticky?: boolean;
}
export function DesignCategoryType({ categorySlug, data, sticky }: Props) {
    const router = useRouter();
    const { props: { countryCode } } = useGlobalContext();
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const container = scrollContainerRef.current;
        const element = document.getElementById(categorySlug);
        if (element && container) {
            const containerWidth = container.offsetWidth;
            const elementLeft = element.offsetLeft;
            const elementWidth = element.offsetWidth;
            const scrollPosition = elementLeft - (containerWidth / 2) + (elementWidth / 2);
            container.scrollTo({
                left: scrollPosition,
                behavior: 'smooth'
            });
        }
    }, [categorySlug]);
    const isFilterPage = (/_[0-9]+$/.test(router.asPath)) || false
    return (
        <div className={sticky ? `${styles.posStickey} ${styles.typeOfModular}` : styles.typeOfModular}>
            <div className={data.length <= 7 ? styles.padding0 + " " + styles.carousel : styles.carousel}>
                <div
                    ref={scrollContainerRef}
                    className={`${styles.carouselBx} scrollBarHide`}
                    id='DesignCategoryType'
                >
                    {data.map((cat, ind) =>
                        <React.Fragment key={ind}>
                            {
                                (!isFilterPage && (categorySlug == cat.categorySlug)) ?
                                    <div className={styles.categoryId} key={cat.categoryId} id={cat.categorySlug}>
                                        <span key={cat.categoryId} onClick={() => pushRoute(`${process.env.SITE_URL}/${countryCode}/interior-design-ideas/${cat.categorySlug}`)} className={`${styles.sildeTile} ${categorySlug == cat.categorySlug && styles.active}`} title={cat.categoryName}>{cat.categoryName}</span>
                                    </div>
                                    :
                                    <NavLink id={cat.categorySlug} href={`${process.env.SITE_URL}/${countryCode}/interior-design-ideas/${cat.categorySlug}`} className={styles.contextMenu} >
                                        <div className={styles.categoryId} key={cat.categoryId} id={cat.categorySlug}>
                                            <span key={cat.categoryId} className={`${styles.sildeTile} ${categorySlug == cat.categorySlug && styles.active}`} title={cat.categoryName}>{cat.categoryName}</span>
                                        </div>
                                    </NavLink>
                            }
                        </React.Fragment>
                    )}
                </div>
                {data.length > 7 ? <CustomSlideArrow slideId={'DesignCategoryType'} slideTileWebWidth={175} slideTileMobWidth={130} edges={true} /> : ""}
            </div>
        </div>
    );
}